module.exports = __webpack_public_path__ + "img/Mage-draenei-f-60.098e69bc.gif";